import React, { useEffect } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Views from "./views";
import "./translations/i18n";
import { changeLanguage } from "./translations/i18n";
import { StockDataProvider } from "./data/hooks/firestore/useStock";
import { ProductsProvider } from "./data/hooks/firestore/useProducts";
import nlNL from "antd/lib/locale/nl_NL";
import "dayjs/locale/nl";
import * as dayjs from "dayjs";
import { ConfigProvider } from "antd";
import { StyleProvider } from "@ant-design/cssinjs";
import "bootstrap/dist/css/bootstrap.css";
import "./assets/css/globals.css";
import { useTranslation } from "react-i18next";
import { CustomersProvider } from "./data/hooks/firestore/useCustomers";
import { CmsUsersProvider } from "./data/hooks/firestore/useCmsUsers";
import { AuthProvider } from "./data/hooks/firebase/useAuth";
import { ExactProvider } from "./data/hooks/exact/useExact";
import { PriceListsProvider } from "./data/hooks/firestore/usePriceLists";
import { VersionProvider } from "./data/hooks/version/useVersion";
import UpdateAvailableModal from "./components/shared-components/UpdateAvailableModal";
import PostHogPageView from "./components/shared-components/PostHogPageView";
import ServiceWorkerManager from "./components/shared-components/ServiceWorkerManager";

dayjs.locale("nl");

const AppContent = () => {
  const { i18n } = useTranslation();

  dayjs.locale(i18n.language);

  useEffect(() => {
    changeLanguage("en");
  }, []);

  return (
    <VersionProvider>
      <PriceListsProvider>
        <ExactProvider>
          <CmsUsersProvider>
            <CustomersProvider>
              <ProductsProvider>
                <StockDataProvider>
                  <StyleProvider>
                    <ConfigProvider
                      locale={nlNL}
                      theme={{
                        token: {
                          colorPrimary: "#880E4F",
                        },
                        components: {
                          Button: {
                            colorLink: "#880E4F",
                            colorLinkHover: "#AC5684",
                          },
                        },
                      }}
                    >
                      <BrowserRouter>
                        <PostHogPageView />
                        <ServiceWorkerManager />
                        <Routes>
                          <Route path="/*" element={<Views />} />
                        </Routes>
                        <UpdateAvailableModal />
                      </BrowserRouter>
                    </ConfigProvider>
                  </StyleProvider>
                </StockDataProvider>
              </ProductsProvider>
            </CustomersProvider>
          </CmsUsersProvider>
        </ExactProvider>
      </PriceListsProvider>
    </VersionProvider>
  );
};

const App = () => {
  return (
    <div className="App">
      <AuthProvider>
        <AppContent />
      </AuthProvider>
    </div>
  );
};

export default App;
